// Screen pixels: the card is HTML above the plan, so these never scale with the zoom.
export const STICKY_NOTE_MIN_WIDTH_PX = 160;
export const STICKY_NOTE_MAX_WIDTH_PX = 264;

// Where MarkerNoteCard's tail tip sits relative to the card: this far in from the left, this far below.
export const STICKY_NOTE_TAIL_INSET_PX = 21;
export const STICKY_NOTE_TAIL_DROP_PX = 6;
